import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { CellButton, CellButtons } from '../CellButton';
import { PerformActionButton } from '../PerformActionButton';
import { View } from '../../../../components/Icon';
import { Loader } from '../../../../components/Loader';

import { VehicleHeader } from '../../../Vehicles/components/VehicleHeader';
import ModalComponent from '../../../../containers/App/Components/Modal/Modal';
import { WithVehicle } from '../../../Vehicles/components/WithVehicle';
import { HBox, VBox } from '../../../../components/Box';
import { Row } from '../../../../components/List';
import { Cell } from '../Cell';
import ButtonComponent from '../../../../containers/App/Components/Button/Button';
import { KanbanVehicleRemarks } from '../../components/KanbanVehicleRemarks';
import { BaseCellComp } from '../BaseCellComp';
import { performAction } from '../../actions';

import { selectVehicle } from '../../../Vehicles/selectors';
import { selectUserId, selectWork, selectWorks } from '../../../Api/selectors';
import { REQUEST_KANBAN_BOARD_PERFORM_ACTION } from '../../constants';
import { REQUEST_VEHICLE_PROPERTY_UPDATE } from '../../../Vehicles/constants';
import { getRemarkType } from '../helpers/getRemarkType';
import { COLOR_PRIMARY_1 } from '../../../../vars';
import styles from './Hooi_Default.module.css';

import { DoubleCheck } from '../../../../containers/App/Components/DoubleCheck/DoubleCheck';

import { Label } from '../../../Vehicles/components/VehicleCounterLabel';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);

const ranges = {
  MediumSeaGreen: [2, 4],
  DarkOrange: [5, 29],
  Crimson: [30, Infinity],
};
const TASK_REMARK_TYPE = 'HOOI_NEW_task_new_tire_order_install';
const Container = styled.div`
  .modal-inner {
  }

  .manco-list > div {
  }
`;

const STATE = {
  approve: false,
  regplate_code: '',
};

/* eslint-disable react/prefer-stateless-function */
class HOOI_NEW_new_tire_order_installComp extends BaseCellComp {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  componentDidUpdate(prevProps, prevState) {
      const { vehicle, setProperty } = this.props;
    if (!vehicle || !prevProps.vehicle) return;

         const watchProps = [
        'HOOI_NEW_order_tire',
  'HOOI_NEW_attach_tire',
      ];
  
 const propChanged = watchProps.some(
    prop => vehicle?.[prop] !== prevProps.vehicle?.[prop]
  );  
      if (propChanged) {
        const today = new Date().toISOString().split('T')[0];
        if (vehicle?.HOOI_NEW_tire_waiting !== today) {
          setProperty('HOOI_NEW_tire_waiting', today);
        }
      }
    }
  
     dateDifference(HOOI_NEW_tire_waiting) {
        const createdDate = HOOI_NEW_tire_waiting || this.propertyValue('HOOI_NEW_tire_waiting');
        if (!createdDate) return 0;
    
        const now = dayjs();
        const created = dayjs(createdDate, 'YYYY-MM-DD'); // <-- correct parse format
    
        if (!created.isValid()) return 0;
    
        const diff = now.diff(created, 'day');
        return diff;
      }

  get vehicle() {
    return this.props.cell.vehicle;
  }
  get doubleCheckProps() {
    return ['HOOI_NEW_order_tire', 'HOOI_NEW_attach_tire'];
  }

  reset() {
    this.setState({ ...STATE });
  }

  confirm() {
    //apprive BVI ...
    this.props.confirm(this.vehicle.id, this.state.regplate_code);
  }

  propertyValue(name) {
    return this.props.vehicle[name];
  }

  disableConfirmation() {
    let disable = false;

    this.doubleCheckProps.forEach(prop => {
      if (!this.props.vehicle[prop]) {
        disable = true;
      }
    });

    return disable;
  }

  renderApprove() {
    if (!this.state.approve) return null;

    return (
      <ModalComponent onClose={this.reset.bind(this)} title={this.props.column.label}>
        <WithVehicle loader vehicle_id={this.vehicle.id}>
          <div className="mb-2">
            <VehicleHeader vehicle={this.vehicle} hooikammer kanbanCell />
          </div>

          <Container>
            <VBox className="manco-list" key="manco">
              <Row>
                <Cell>
                  <DoubleCheck key={'HOOI_NEW_order_tire'} name={'HOOI_NEW_order_tire'} vehicle={this.props.vehicle} />
                </Cell>
              </Row>
              {this.propertyValue('HOOI_NEW_order_tire') === '1' && (
                <Row>
                  <Cell>
                    <DoubleCheck key={'HOOI_NEW_attach_tire'} name={'HOOI_NEW_attach_tire'} vehicle={this.props.vehicle} />
                  </Cell>
                </Row>
              )}

              <HBox className="mt-3">
                {this.props.workRemarks ? (
                  <Loader small />
                ) : (
                  <KanbanVehicleRemarks
                    key={'modal'}
                    fullWidth={true}
                    taskName={TASK_REMARK_TYPE}
                    kanbanBoardLabel={this.props.board?.label}
                    vehicleId={this.vehicle.id}
                    loggedUserId={this.props.loggedInUserId}
                  />
                )}
              </HBox>
            </VBox>
          </Container>
        </WithVehicle>
        <div className="d-flex gap-2 mt-3">
          <PerformActionButton
            disabled={this.disableConfirmation()}
            className={styles.confirmButton}
            action={this.props.action}
            target={this.vehicle}
            onChange={this.reset.bind(this)}
          />

          <ButtonComponent style={'ButtonSoftDelete'} onClick={this.reset.bind(this)}>
            {this.lbl('cancel')}
          </ButtonComponent>
        </div>
      </ModalComponent>
    );
  }

  renderIcon(vehicle) {
    if (
      (vehicle.HOOI_NEW_order_tire == '1' && !vehicle.HOOI_NEW_attach_tire)

    ) {
      return (
        <img
          src="https://vindat.indewal.nl/storage/documents/ac98742c-10cb-41c6-980f-952787ea0dbb.png"
          alt="Kleine afbeelding"
          style={{ width: '25px', height: '25px', margin: '5px' }}
        />
      );
    }}

  render() {
    const vehicle = this.vehicle;
    const Date = vehicle.HOOI_NEW_tire_waiting || dayjs();;

    const days = this.dateDifference(Date);
    let message = '';
        
        if (vehicle.HOOI_NEW_order_tire === '1' && !vehicle.HOOI_NEW_attach_tire) {
          message = 'Wacht op: Banden';
        }
    return (
      <Cell>
        <Container>
          <VehicleHeader vehicle={vehicle} kanbanCell />
          <Label count={days} ranges={ranges}>
                                {days}
                              </Label>{message}
          <CellButtons>
          {this.renderIcon(vehicle)}
            {this.props.cell.busy ? (
              <Loader small />
            ) : (
              <>
                {this.props.workRemarks ? (
                  <Loader small />
                ) : (
                  <KanbanVehicleRemarks
                    readOnly
                    taskName={TASK_REMARK_TYPE}
                    kanbanBoardLabel={this.props.board?.label}
                    vehicleId={this.vehicle.id}
                    loggedUserId={this.props.loggedInUserId}
                  />
                )}
                <CellButton
                  onClick={this.setStateFn({ approve: !this.state.approve, regplate_code: vehicle.regplate_code || '' })}
                >
                  <View />
                </CellButton>
              </>
            )}
          </CellButtons>
        </Container>
        {this.renderApprove()}
      </Cell>
    );
  }
}

HOOI_NEW_new_tire_order_installComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([`${REQUEST_KANBAN_BOARD_PERFORM_ACTION + ownProps.actionId}_${ownProps.cell.vehicle?.id}`]),
    vehicle: selectVehicle(ownProps.cell.vehicle.id),
    loggedInUserId: selectUserId(),
    workRemarks: selectWork(`${REQUEST_VEHICLE_PROPERTY_UPDATE}-${getRemarkType(TASK_REMARK_TYPE)}`),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    confirm(vehicle_id, regplate_code) {
      dispatch(performAction(ownProps.action.id, vehicle_id, { regplate_code }));
    },
    setProperty(propertyName, value) {
      dispatch({
        type: REQUEST_VEHICLE_PROPERTY_UPDATE,
        payload: { name: propertyName, value },
      });
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const HOOI_NEW_new_tire_order_install = compose(withConnect, withRouter)(HOOI_NEW_new_tire_order_installComp);
